import { ReactNode } from 'react'
import { z } from 'zod'

export const NoteFormSchema = z.object({
  id: z.number().optional(),
  noteBody: z
    .string()
    .min(1, 'This field is required')
    .max(260, 'Description must be maximum 260 characters'),
  title: z
    .string()
    .min(1, 'This field is required')
    .max(200, 'Name must be maximum 200 characters'),
})

export type NoteFormData = z.infer<typeof NoteFormSchema>

export type DetailsInfoItem = {
  label: string
  value: ReactNode
  hidden?: boolean
}
